import { ApiV2Service } from '@src/service/api-v2.service';
import { generateUUID } from '../lib';
const { default: kountSdk } = require('@kount/kount-web-client-sdk');

export class EquifaxKountService extends ApiV2Service {
  static serviceName = 'EquifaxKountService';

  private static config = {
    isDebugEnabled: false,
    // clientID assigned to you by Kount
    clientID: '743659474122018',
    // Environment for data collection provided by Kount
    environment: process.env.STAGE !== 'production' ? 'TEST' : 'PROD',
    // Or true, changes some internal behavior
    isSinglePageApp: true,
  };

  private static instance: any | undefined;

  static logger = (...args: any[]) => {
    if (this.environment === 'dev') {
      console.log(`%c[${this.serviceName}] :: `, 'color:DodgerBlue', args.join(''));
    }
  };

  static get sessionId(): string {
    return this.instance.sessionID;
  }

  static start(): string {
    if (!this.instance) {
      this.instance = kountSdk(this.config, generateUUID().replaceAll('-', ''));
    }

    return this.sessionId;
  }
}
